/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Paste_Events_CancelInputs */



/**
* | output |
* | --- |
* | "Use Original Timing" |
*
* @param {Shortcut_Keys_Paste_Events_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_paste_events_cancel = /** @type {((inputs?: Shortcut_Keys_Paste_Events_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Paste_Events_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utiliser le minutage original")
	if (locale === "de") return /** @type {LocalizedString} */ ("Originale Zündung verwenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Usa la temporizzazione originale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Использовать исходное время")
	if (locale === "es") return /** @type {LocalizedString} */ ("Utilice la sincronización original")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("使用原时序")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オリジナルのタイミングを使用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मूल समय का उपयोग करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Usar a sincronização original")
	return /** @type {LocalizedString} */ ("Use Original Timing")
});